import React, { useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper";

function Section05({ inView5, ref5 }) {

    return (
        <React.Fragment>
            <article
                ref={ref5}
                className={classNames("section05", {
                    on: inView5 == true,
                })}>
                <div className="footer">
                    <div className="footer-title">
                        yhocool@naver.com
                        <br />
                        <div className="mail">
                            피드백은 항상 감사합니다 :)
                        </div>
                    </div>


                    <div className="endText">
                        <div className="name">이윤호</div>
                        © LEE YOON HO 2022
                    </div>



                </div >

            </article >
        </React.Fragment >
    );
}

export default connect(
    // props 로 넣어줄 스토어 상태값
    (state) => ({
        layout: state.layout,
    })
)(Section05);

